<template>
    <div>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100vh;">
            <b-row class="mx-auto justify-content-end"
                v-if="user_type == 'operator'&& quote_data&& quote_data.owner !=null && quote_data.owner.id == user_id && !quote_data.paid">
                <b-col cols="auto">
                    <router-link class="btn btn-bumblebee btn-garden-help btn-garden-help-primary-link btn-lg py-1"
                        :to="base_url + '/edit'">
                        <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                        Edit Quote
                    </router-link>
                </b-col>
            </b-row>

            <GardenHelpQuoteDetails class="" v-if="quote_data != null && quote_job != null"
                :quote_table_items="quote_data.items" :contractor_name="quote_data.owner.name"
                :issue_date="quote_data.created_at" :booking_date="quote_job.details.booking_date_web"
                :job_type="quote_job.property.type" :quote_number="quote_data.invoice_number"
                :customer_name="quote_job.contact.name" :quote_status="quote_data.status" :subtotal="quote_data.subtotal"
                :vat="quote_data.vat" :total="quote_data.total" :currency_code="currency_code"
                :currency_icon="currency_icon" :company_logo="company_logo"
                :contractor_phone="quote_data.owner.phone"
                :contractor_email="quote_data.owner.email"
                :company_reg_no="quote_data.owner.company_reg_no"
                :contractor_address="quote_data.owner.address"
                :vat_number="quote_data.owner.vat_number" :quote_paid="quote_data.paid" :is-quote="false"
            />
        </b-overlay>
    </div>
</template>

<script>
import { getJobStatusClassAndStr } from "@/utils/helper-functions-garden-help.js"
import { formatDateToDMonYear } from "@/utils/helper-functions.js"
import GardenHelpQuoteDetails from "./QuoteDetails.vue"
import countries_list from '@/assets/country-list-data.json'

import axios from "axios";

export default {
    name: "GardenHelpViewQuote",
    components: {
        GardenHelpQuoteDetails
    },
    data() {
        return {
            client_name: "GARDENHELP",
            show_overlay: true,

            quote_id: null,
            quote_data: {
                "status": "",
                "subtotal": 0,
                "vat": 0,
                "total": 0,
                "currency": "eur",
                "model_type": "Job",
                "model_id": null,
                "client": "GARDENHELP",
                "invoice_items": []
            },
            quote_job: null,
            user_id: null,
            user_type: null,
            vat_no: null,

            action: 'view',
            base_url: null,

            country: null,
            currency_code: null,
            currency_icon: null,

            company_logo: null,
            company_reg_no: null

        };
    },
    beforeMount() {
        this.show_overlay = true
    },
    mounted() {
        this.quote_id = Number(this.$route.params.id);
        this.user_type = localStorage.getItem('user_type')
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        this.base_url = this.$route.path

        this.show_overlay = true
        this.getQuoteDetails()

        if (this.user_type == 'operator') {
            this.getContractorData()
        }
    },
    methods: {
        getQuoteDetails() {
            // this.show_overlay = true
            axios
                .get("/payment/invoices/" + this.quote_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    this.quote_data = response.data
                    this.getJobDetails(response.data.model.id)
                    console.log(response.data.currency)
                    this.currency_code = response.data.currency
                    const country_data = countries_list.find(({ currency_code }) => currency_code === this.currency_code);

                    this.country = country_data.country
                    this.currency_icon = country_data.currency_icon
                });
        },
        getJobDetails(id) {
            axios
                .get("/jobs/jobs/" + id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)

                    this.quote_job = response.data

                    this.show_overlay = false
                });
        },

        getContractorData() {
            console.log("in get contractor data", this.user_type, this.user_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile", {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    this.vat_no = response.data.vat_no
                    this.company_reg_no =response.data.company_reg_no
                    this.company_logo = response.data.logo


                });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/ViewQuote.vue